// extracted by mini-css-extract-plugin
export default {"mainDiv":"QRCode_mainDiv__w1UQT","qrButton":"QRCode_qrButton__0Eauu"};